var devicetypes = {
    list: function(page){
        var params = utils.getParamObj();
        params.like = $("#like").val();
        params.page = page || 1;

        var getParams = location.pathname+"?"+($.param(params));

        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);

            $.get(getParams,params,function(resp){
                $("#zone_devicetypes_list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },

    new: function(){
        $.post('/stages/devicetypes/new/0', {_token: utils.getToken()}, function(resp){
            popup(resp, 'Add new Device Type').dialog();
        })
    },

    devicetype: function(devicetypeID){
        $.post('/stages/devicetypes/devicetype/' + devicetypeID, {_token: utils.getToken()}, function(resp){
            popup(resp, 'Edit Device Type').dialog();
        })
    },

    save: function(devicetypeID){
        var params = $("form#devicetypesForm :input").serializeObj();
        params._token = utils.getToken();

        $.post('/stages/devicetypes/save/' + devicetypeID, params, function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    addPortPopup: function(devicetypeID){
        $.post('/stages/devicetypes/addPortPopup/' + devicetypeID, {_token: utils.getToken()}, function(resp){
            if(resp) {
                popup(resp, 'Add Port Types').dialog();
            }
        });
    },
    porttypeSave: function(devicetypeID){
        var params = $("form#deviceTypePortsForm :input").serializeObj();
        params._token = utils.getToken();
        params.devicetypeID = devicetypeID;

        $.post('/stages/devicetypes/porttypeSave/0', params, function(resp){
            if(resp) {
                popupInstance[popupInstance.length - 1].close();
                $('#portTypesTableBody').html(resp).show();
            }
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    changePorttypeField: function(data, newValue){
        var params = {_token: utils.getToken(), data: data, newValue: newValue};

        $.post('/stages/devicetypes/changePorttypeField', params, function(resp){
            $('#' + data).removeClass('editable-unsaved');
        })
    },


};